module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"siteTitle":"Raw Data Export"},"de":{"siteTitle":"Rohdaten-Export"},"fr":{"siteTitle":"Exportation des données brutes"},"it":{"siteTitle":"Esportazione dati grezzi"}}')
  delete Component.options._Ctor
}
